// src/api/newTipV2Api.js
//
// Wrapper des endpoints back-office New TIP v2.
// Utilise l'instance HTTP custom (src/http-common.js).
// Toutes les URLs sont relatives à la baseURL (qui contient déjà /api/).

import { HTTP } from '@/http-common';

const BASE = 'admin/new-tip-v2';

export default {
  // ---- Campagnes -------------------------------------------------------
  listCampaigns(params = {}) {
    return HTTP.get(`${BASE}/campaigns`, { params });
  },
  showCampaign(id) {
    return HTTP.get(`${BASE}/campaigns/${id}`);
  },
  createCampaign(payload) {
    return HTTP.post(`${BASE}/campaigns`, payload);
  },
  updateCampaign(id, payload) {
    return HTTP.put(`${BASE}/campaigns/${id}`, payload);
  },
  deleteCampaign(id) {
    return HTTP.delete(`${BASE}/campaigns/${id}`);
  },

  // ---- Affectations ----------------------------------------------------
  listAssignments(campaignId, params = {}) {
    return HTTP.get(`${BASE}/campaigns/${campaignId}/assignments`, { params });
  },
  storeAssignmentsBulk(campaignId, assignments) {
    return HTTP.post(`${BASE}/campaigns/${campaignId}/assignments`, { assignments });
  },
  importAssignments(campaignId, file, onProgress = null) {
    const formData = new FormData();
    formData.append('file', file);
    return HTTP.post(
      `${BASE}/campaigns/${campaignId}/assignments/import`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: onProgress,
      },
    );
  },
  deleteAssignment(assignmentId) {
    return HTTP.delete(`${BASE}/assignments/${assignmentId}`);
  },

  // ---- Dashboard -------------------------------------------------------
  dashboard(filters = {}) {
    return HTTP.get(`${BASE}/dashboard`, { params: filters });
  },
  exportDashboard(filters = {}) {
    return HTTP.get(`${BASE}/dashboard/export`, {
      params: filters,
      responseType: 'blob',
    });
  },

  // ---- Visites (review admin) -----------------------------------------
  showVisit(id) {
    return HTTP.get(`${BASE}/visits/${id}`);
  },
  reviewVisit(id, action, rejectionReason = null) {
    return HTTP.post(`${BASE}/visits/${id}/review`, {
      action,
      rejection_reason: rejectionReason,
    });
  },

  // ---- Helpers (endpoints hors module, utilisés par les écrans v2) ----

  /**
   * Produits actifs, pour le sélecteur de produit d'une campagne.
   * Une campagne v2 porte un seul produit : c'est sur sa quantité en stock
   * que portent les 3 paliers.
   */
  listProducts() {
    return HTTP.get('products/active');
  },

  /**
   * Recherche paginée de POS dans la base globale (pour autocomplete).
   */
  searchSalepoints(keyword = '', perPage = 10) {
    return HTTP.get('database', {
      params: {
        page: 1,
        keyword,
        per_page: perPage,
        filter: JSON.stringify({
          have_account: 'all',
          have_tip_account: 'all',
          salepoint_platinum: 'all',
          cities: [],
        }),
      },
    });
  },

  getSalepoint(id) {
    return HTTP.get(`database/${id}`);
  },

  listSupervisors() {
    return HTTP.get('supervisors');
  },
};
